/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.29.4-beta.0.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { WorkorderFromJSON, WorkorderToJSON, } from './';
export function StopLaborTimerCommandFromJSON(json) {
    return StopLaborTimerCommandFromJSONTyped(json, false);
}
export function StopLaborTimerCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'timerEndDateTime': !exists(json, 'timerEndDateTime') ? undefined : (new Date(json['timerEndDateTime'])),
        'workorder': !exists(json, 'workorder') ? undefined : WorkorderFromJSON(json['workorder']),
    };
}
export function StopLaborTimerCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'timerEndDateTime': value.timerEndDateTime === undefined ? undefined : (value.timerEndDateTime.toISOString()),
        'workorder': WorkorderToJSON(value.workorder),
    };
}
